export default __webpack_public_path__ + "static/media/danger.a15b1e73.svg";